<!-- =========================================================================================
  File Name: AddNewDataSidebar.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<vs-popup v-if="!isMobile()" :title="Object.entries(this.data).length === 0
		? $t('AddNewStorehouse')
		: $t('UPDATEStorehouse')
		" button-cancel="border" :active.sync="isSidebarActiveLocal" classContent="popup-example">
		<CustomerInfoAddNew :isSidebarInfoActive="addNewInfoDataSidebar" :data="infoData" />

		<vs-card>
			<component :is="scrollbarTag" ref="scroll" class="scroll-area--data-list-add-new" :settings="settings"
				:key="$vs.rtl">
				<div class="p-6">
					<b-row>
						<b-col>
							<div v-if="type == 'dropshipping'">
								{{ customer_choices }}
								<b-row v-if="ROLE != 'Company'" class="mb-2">
									<b-col cols="4" align-self="center">
										<b-form-group :label="'* ' + $t('Customer')" class="vs-input--label pr-0 mr-0"
											label-for="h-first-name">
										</b-form-group>
									</b-col>
									<b-col cols="8">
										<v-select color="danger" v-model="customer" :options="customer_choices" size="small" label="name"
											v-if="depotId || company" disabled v-on:input="getCustomerinfoList" autocomplete
											ref="selectElement" name="customer" v-validate="'required'">
										</v-select>
										<v-select color="danger" v-model="customer" :options="customer_choices" size="small" label="name"
											v-else v-on:input="getCustomerinfoList" autocomplete ref="selectElement" name="customer"
											v-validate="'required'">
										</v-select>
										<span class="text-danger text-sm" v-show="errors.has('customer')">{{ errors.first('customer')
										}}</span>
									</b-col>
								</b-row>

								<b-row align-v="center">
									<b-col cols="4" align-self="center">
										<b-form-group :label="'* ' + $t('CompanyInfo')" class="vs-input--label pr-0 mr-0"
											label-for="h-first-name">
										</b-form-group>
									</b-col>
									<b-col :cols="ROLE != 'Company' ? 7 : 8">
										<v-select color="danger" v-model="customerinfo" :options="customerinfo_choices" size="small"
											label="name" v-if="depotId" disabled autocomplete ref="selectElement" name="customerinfo"
											v-validate="'required'">
										</v-select>
										<v-select color="danger" v-model="customerinfo" :options="customerinfo_choices" size="small"
											label="name" v-else autocomplete ref="selectElement" name="customerinfo" v-validate="'required'">
										</v-select>
										<span class="text-danger text-sm" v-show="errors.has('customerinfo')">{{
											errors.first('customerinfo')
										}}</span>
									</b-col>
									<b-col v-if="ROLE != 'Company'" cols="1" class="ml-0"
										style="padding-left: 0px; margin-left: 0px !important;">

										<b-button v-if="customer != ''" variant="outline-light" style="padding: 0px;"
											v-on:click="addCustomerInfo();">
											<Icon icon="ic:outline-settings" width="20" height="20"
												v-b-tooltip.hover.bottom="$t('CompanyManagement')" color="#7367F0" />
										</b-button>
										<b-button v-else disabled variant="outline-light" style="padding: 0px;"
											v-on:click="addCustomerInfo();">
											<Icon icon="ic:outline-settings" width="20" height="20"
												v-b-tooltip.hover.bottom="$t('CompanyManagement')" color="#7367F0" />
										</b-button>
									</b-col>
								</b-row>
							</div>
							<b-row class="mt-2">
								<b-col cols="4" align-self="center">
									<b-form-group :label="'* ' + $t('DepotName')" class="vs-input--label pr-0 mr-0"
										label-for="h-first-name" style="font-weight: 600">
									</b-form-group>
								</b-col>
								<b-col cols="8">
									<vs-input size="small" v-model="depotName" type="text" class="w-full" name="depotName"
										v-validate="'required'" />
									<span class="text-danger text-sm" v-show="errors.has('depotName')">{{
										errors.first("depotName")
									}}</span>
								</b-col>
							</b-row>

							<b-row class="mt-2">
								<b-col cols="4" align-self="center">
									<b-form-group :label="'* ' + $t('DepotNo')" class="vs-input--label pr-0 mr-0" label-for="h-first-name"
										style="font-weight: 600">
									</b-form-group>
								</b-col>
								<b-col cols="8">
									<vs-input size="small" v-model="depotNo" type="text" class="w-full" v-validate="'required'"
										name="depotNo" />
									<span class="text-danger text-sm" v-show="errors.has('depotNo')">{{
										errors.first("depotNo")
									}}</span>
								</b-col>
							</b-row>
							<b-row class="mt-2">
								<b-col cols="4" align-self="center">
									<b-form-group :label="'* ' + $t('DropShipingDepot')" class="vs-input--label pr-0 mr-0"
										label-for="h-first-name" style="font-weight: 600">
									</b-form-group>
								</b-col>
								<b-col cols="8">
									<vs-switch style="border-radius: 20px" v-model="usingDropShiping" v-validate="'required'"
										name="DropShiping" />

									<span class="text-danger text-sm" v-show="errors.has('DropShiping')">{{
										errors.first("DropShiping")
									}}</span>
								</b-col>
							</b-row>

							<b-row class="mt-2">
								<b-col cols="4" align-self="center">
									<b-form-group :label="$t('DepotType')" class="vs-input--label pr-0 mr-0" label-for="h-first-name"
										style="font-weight: 600">
									</b-form-group>
								</b-col>
								<b-col cols="8">
									<v-select color="danger" v-model="depotType" :options="depotType_choices" size="small" label="name"
										autocomplete ref="selectElement">
									</v-select>
								</b-col>
							</b-row>
							<b-row class="mt-2">
								<b-col cols="4" align-self="center">
									<b-form-group :label="$t('GroupCode')" class="vs-input--label pr-0 mr-0" label-for="h-first-name"
										style="font-weight: 600">
									</b-form-group>
								</b-col>
								<b-col cols="8">
									<vs-input size="small" v-model="groupCode" type="text" class="w-full" />
								</b-col>
							</b-row>
							<b-row class="mt-2">
								<b-col cols="4" align-self="center">
									<b-form-group :label="$t('SpecCode') + '1'" class="vs-input--label pr-0 mr-0" label-for="h-first-name"
										style="font-weight: 600">
									</b-form-group>
								</b-col>
								<b-col cols="8">
									<vs-input size="small" v-model="specCode1" type="text" class="w-full" />
								</b-col>
							</b-row>
							<b-row class="mt-2">
								<b-col cols="4" align-self="center">
									<b-form-group :label="$t('SpecCode') + '2'" class="vs-input--label pr-0 mr-0" label-for="h-first-name"
										style="font-weight: 600">
									</b-form-group>
								</b-col>
								<b-col cols="8">
									<vs-input size="small" v-model="specCode2" type="text" class="w-full" />
								</b-col>
							</b-row>
							<b-row class="mt-2">
								<b-col cols="4" align-self="center">
									<b-form-group :label="$t('Status')" class="vs-input--label pr-0 mr-0" label-for="h-first-name"
										style="font-weight: 600">
									</b-form-group>
								</b-col>
								<b-col cols="8">
									<v-select color="danger" v-model="status" :options="status_choices" size="small" label="text"
										autocomplete ref="selectElement">
									</v-select>
								</b-col>
							</b-row>
							<b-row class="mt-2">
								<b-col cols="4" align-self="center">
									<b-form-group :label="$t('Note')" class="vs-input--label pr-0 mr-0" label-for="h-first-name"
										style="font-weight: 600">
									</b-form-group>
								</b-col>
								<b-col cols="8">
									<vs-textarea v-model="note" />
								</b-col>
							</b-row>
							<b-row>
								<b-col cols="4" align-self="center">
									<b-form-group :label="$t('CancelDate')" class="vs-input--label pr-0 mr-0" label-for="h-first-name"
										style="font-weight: 600">
									</b-form-group>
								</b-col>
								<b-col cols="8">
									<b-form-datepicker id="baslangic" v-model="cancelDate" size="md" :locale="locale" class="mb-2"
										today-variant="danger" placeholder="-" :start-weekday="weekday" :date-format-options="{
											year: 'numeric',
											month: 'numeric',
											day: 'numeric',
										}" />
								</b-col>
							</b-row>

							<b-row>
								<b-col cols="4" align-self="center">
									<b-form-group :label="$t('Country')" class="vs-input--label pr-0 mr-0" label-for="h-first-name"
										style="font-weight: 600">
									</b-form-group>
								</b-col>
								<b-col cols="8">
									<vs-input size="small" v-model="country" type="text" class="w-full" />
								</b-col>
							</b-row>

							<b-row class="mt-2">
								<b-col cols="4" align-self="center">
									<b-form-group :label="$t('Description')" class="vs-input--label pr-0 mr-0" label-for="h-first-name"
										style="font-weight: 600">
									</b-form-group>
								</b-col>
								<b-col cols="8">
									<vs-textarea v-model="description" />
								</b-col>
							</b-row>
							<b-row class="mt-2">
								<b-col>
									<vs-checkbox color="primary" style="font-weight: 600" v-model="remControl">{{ $t("RemControl")
									}}</vs-checkbox>
								</b-col>
							</b-row>
						</b-col>
					</b-row>
				</div>
			</component>
		</vs-card>

		<div class="items-center pl-6 mt-0 mb-0">
			<b-row align-h="end">
				<b-col cols="3" md="auto" style="padding: 0px">
					<b-button class="bg-danger" style="border-color: white" v-on:click="isSidebarActiveLocal = false">
						<Icon icon="material-symbols:cancel-outline" style="margin-right: 5px" width="20" height="20" />{{
							$t("Cancel") }}
					</b-button>
				</b-col>
				<b-col cols="3" md="auto">
					<b-button class="bg-primary" style="border-color: white" v-on:click="submitData()">
						<Icon icon="material-symbols:save-outline" style="margin-right: 5px" width="20" height="20" />{{ $t("Save")
						}}
					</b-button>
				</b-col>
			</b-row>
		</div>
	</vs-popup>
	<vs-sidebar v-else click-not-close position-right parent="body" default-index="1" color="primary"
		class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
		<CustomerInfoAddNew :isSidebarInfoActive="addNewInfoDataSidebar" :data="infoData" />
		<div class="mt-6 flex items-center justify-between px-6">
			<h4>{{ Object.entries(this.data).length === 0 ? $t("AddNew") : $t("UPDATE") }}</h4>
			<feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
		</div>
		<vs-divider class="mb-0"></vs-divider>
		<component :is="scrollbarTag" class="scroll-area--data-list-add-new-mobile2" :settings="settings" :key="$vs.rtl">
			<div class="p-6">
				<b-row v-if="ROLE != 'Company'" class="mb-2">
					<b-col cols="4" align-self="center">
						<b-form-group :label="'* ' + $t('Customer')" class="vs-input--label pr-0 mr-0" label-for="h-first-name"
							style="font-weight: 600">
						</b-form-group>
					</b-col>
					<b-col cols="8">
						<v-select color="danger" v-model="customer" :options="customer_choices" size="small" label="name"
							v-if="depotId || company" disabled v-on:input="getCustomerinfoList" autocomplete ref="selectElement"
							name="customer" v-validate="'required'">
						</v-select>
						<v-select color="danger" v-model="customer" :options="customer_choices" size="small" label="name" v-else
							v-on:input="getCustomerinfoList" autocomplete ref="selectElement" name="customer" v-validate="'required'">
						</v-select>
						<span class="text-danger text-sm" v-show="errors.has('customer')">{{
							errors.first("customer")
						}}</span>
					</b-col>
				</b-row>

				<b-row align-v="center">
					<b-col cols="4" align-self="center">
						<b-form-group :label="'* ' + $t('CompanyInfo')" class="vs-input--label pr-0 mr-0" label-for="h-first-name"
							style="font-weight: 600">
						</b-form-group>
					</b-col>
					<b-col :cols="ROLE != 'Company' ? 7 : 8">
						<v-select color="danger" v-model="customerinfo" :options="customerinfo_choices" size="small" label="name"
							v-if="depotId" disabled autocomplete ref="selectElement" name="customerinfo" v-validate="'required'">
						</v-select>
						<v-select color="danger" v-model="customerinfo" :options="customerinfo_choices" size="small" label="name"
							v-else autocomplete ref="selectElement" name="customerinfo" v-validate="'required'">
						</v-select>
						<span class="text-danger text-sm" v-show="errors.has('customerinfo')">{{
							errors.first("customerinfo")
						}}</span>
					</b-col>
					<b-col v-if="ROLE != 'Company'" cols="1" class="ml-0" style="padding-left: 0px; margin-left: 0px !important">
						<b-button v-if="customer != ''" variant="outline-light" style="padding: 0px" v-on:click="addCustomerInfo()">
							<Icon icon="ic:outline-settings" width="20" height="20" v-b-tooltip.hover.bottom="$t('CompanyManagement')"
								color="#7367F0" />
						</b-button>
						<b-button v-else disabled variant="outline-light" style="padding: 0px" v-on:click="addCustomerInfo()">
							<Icon icon="ic:outline-settings" width="20" height="20" v-b-tooltip.hover.bottom="$t('CompanyManagement')"
								color="#7367F0" />
						</b-button>
					</b-col>
				</b-row>

				<b-row class="mt-2">
					<b-col cols="4" align-self="center">
						<b-form-group :label="'* ' + $t('DepotName')" class="vs-input--label pr-0 mr-0" label-for="h-first-name"
							style="font-weight: 600">
						</b-form-group>
					</b-col>
					<b-col cols="8">
						<vs-input size="small" v-model="depotName" type="text" class="w-full" name="depotName"
							v-validate="'required'" />
						<span class="text-danger text-sm" v-show="errors.has('depotName')">{{
							errors.first("depotName")
						}}</span>
					</b-col>
				</b-row>

				<b-row class="mt-2">
					<b-col cols="4" align-self="center">
						<b-form-group :label="'* ' + $t('DepotNo')" class="vs-input--label pr-0 mr-0" label-for="h-first-name"
							style="font-weight: 600">
						</b-form-group>
					</b-col>
					<b-col cols="8">
						<vs-input size="small" v-model="depotNo" type="text" class="w-full" v-validate="'required'"
							name="depotNo" />
						<span class="text-danger text-sm" v-show="errors.has('depotNo')">{{
							errors.first("depotNo")
						}}</span>
					</b-col>
				</b-row>
				<b-row class="mt-2">
					<b-col cols="4" align-self="center">
						<b-form-group :label="$t('DepotType')" class="vs-input--label pr-0 mr-0" label-for="h-first-name"
							style="font-weight: 600">
						</b-form-group>
					</b-col>
					<b-col cols="8">
						<v-select color="danger" v-model="depotType" :options="depotType_choices" size="small" label="name"
							autocomplete ref="selectElement">
						</v-select>
					</b-col>
				</b-row>
				<b-row class="mt-2">
					<b-col cols="4" align-self="center">
						<b-form-group :label="$t('GroupCode')" class="vs-input--label pr-0 mr-0" label-for="h-first-name"
							style="font-weight: 600">
						</b-form-group>
					</b-col>
					<b-col cols="8">
						<vs-input size="small" v-model="groupCode" type="text" class="w-full" />
					</b-col>
				</b-row>
				<b-row class="mt-2">
					<b-col cols="4" align-self="center">
						<b-form-group :label="$t('SpecCode') + '1'" class="vs-input--label pr-0 mr-0" label-for="h-first-name"
							style="font-weight: 600">
						</b-form-group>
					</b-col>
					<b-col cols="8">
						<vs-input size="small" v-model="specCode1" type="text" class="w-full" />
					</b-col>
				</b-row>
				<b-row class="mt-2">
					<b-col cols="4" align-self="center">
						<b-form-group :label="$t('SpecCode') + '2'" class="vs-input--label pr-0 mr-0" label-for="h-first-name"
							style="font-weight: 600">
						</b-form-group>
					</b-col>
					<b-col cols="8">
						<vs-input size="small" v-model="specCode2" type="text" class="w-full" />
					</b-col>
				</b-row>
				<b-row class="mt-2">
					<b-col cols="4" align-self="center">
						<b-form-group :label="$t('Status')" class="vs-input--label pr-0 mr-0" label-for="h-first-name"
							style="font-weight: 600">
						</b-form-group>
					</b-col>
					<b-col cols="8">
						<v-select color="danger" v-model="status" :options="status_choices" size="small" label="text" autocomplete
							ref="selectElement">
						</v-select>
					</b-col>
				</b-row>
				<b-row class="mt-2">
					<b-col cols="4" align-self="center">
						<b-form-group :label="$t('Note')" class="vs-input--label pr-0 mr-0" label-for="h-first-name"
							style="font-weight: 600">
						</b-form-group>
					</b-col>
					<b-col cols="8">
						<vs-textarea v-model="note" />
					</b-col>
				</b-row>
				<b-row>
					<b-col cols="4" align-self="center">
						<b-form-group :label="$t('CancelDate')" class="vs-input--label pr-0 mr-0" label-for="h-first-name"
							style="font-weight: 600">
						</b-form-group>
					</b-col>
					<b-col cols="8">
						<b-form-datepicker id="baslangic" v-model="cancelDate" size="md" :locale="locale" class="mb-2"
							today-variant="danger" placeholder="-" :start-weekday="weekday" :date-format-options="{
								year: 'numeric',
								month: 'numeric',
								day: 'numeric',
							}" />
					</b-col>
				</b-row>

				<b-row>
					<b-col cols="4" align-self="center">
						<b-form-group :label="$t('Country')" class="vs-input--label pr-0 mr-0" label-for="h-first-name">
						</b-form-group>
					</b-col>
					<b-col cols="8">
						<vs-input size="small" v-model="country" type="text" class="w-full" />
					</b-col>
				</b-row>

				<b-row class="mt-2">
					<b-col cols="4" align-self="center">
						<b-form-group :label="$t('Description')" class="vs-input--label pr-0 mr-0" label-for="h-first-name">
						</b-form-group>
					</b-col>
					<b-col cols="8">
						<vs-textarea v-model="description" />
					</b-col>
				</b-row>
				<b-row class="mt-2">
					<b-col>
						<vs-checkbox color="primary" v-model="remControl">{{
							$t("RemControl")
						}}</vs-checkbox>
					</b-col>
				</b-row>
			</div>
		</component>

		<div class="flex flex-wrap items-center p-6" slot="footer">
			<!--		<vs-button class="mr-6" @click="submitData" :disabled="!isFormValid">Submit</vs-button>-->
			<b-button class="bg-primary" style="border-color: white" v-on:click="submitData()">
				<Icon icon="material-symbols:save-outline" width="20" height="20" />{{
					$t("Save")
				}}
			</b-button>
			<b-button class="bg-danger" style="border-color: white" v-on:click="isSidebarActiveLocal = false">
				<Icon icon="material-symbols:cancel-outline" width="20" height="20" />{{
					$t("Cancel")
				}}
			</b-button>
		</div>
	</vs-sidebar>
</template>

<script>
import { isMobile } from "mobile-device-detect";
import CustomerInfoAddNew from "../customer/CustomerInfoAddNew.vue";
import { Validator } from "vee-validate";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import vSelect from "vue-select";
import { Icon } from "@iconify/vue2";
import { uuid } from "vue-uuid";
import moment from "moment";
import userJson from "../../../public/user.json";

export default {
	props: {
		isSidebarActiveStorehouse: {
			type: Boolean,
			required: true,
		},
		data: {
			default: () => { },
		},
		company: { default: () => { } },
	},
	components: {
		CustomerInfoAddNew,
		VuePerfectScrollbar,
		vSelect,
		Icon,
		uuid,
	},
	mounted() {
		//tables global olarak tanımlanıyor

		this.$root.$on("addInfoData", (data) => {
			this.addInfoData(data);
		});
		this.$root.$on("closeInfoData", () => {
			this.closeInfoData();
		});
		this.$root.$on("getCustomerinfoList", () => {
			this.getCustomerinfoList();
		});
	},
	beforeDestroy() {
		this.$root.$off("addInfoData");
		this.$root.$off("closeInfoData");
		this.$root.$off("getCustomerinfoList");
	},
	data() {
		return {
			type: userJson.type,
			ROLE: this.$store.state.AppActiveUser.ROLE,
			isMobile: function () {
				return isMobile;
			},
			findCustomerInfoId: "",
			infoData: [],
			addNewInfoDataSidebar: false,
			findedCustomerId: "",
			customerInfoListF: [],
			customerinfo: "",
			customer: "",
			customerListOption: [],
			customer_choices: [{ value: "", name: "" }],
			customerinfo_choices: [{ value: "", name: "" }],
			weekday: 1,
			depotId: "",
			depotType: {
				text: this.$t("ProductEnter"),
				value: 1,
			}, //
			depotNo: "", //
			country: "", //
			depotName: "", //
			groupCode: "", //
			specCode1: "", //
			specCode2: "", //
			status: 0, //
			note: "",
			cancelDate: "", //
			description: "", //
			depotGroupId: "",
			remControl: "",
			companyInfoId: "",
			usingDropShiping: false,
			settings: {
				// perfectscrollbar settings
				maxScrollbarLength: 60,
				wheelSpeed: 0.6,
			},
			status_choices: [
				{
					text: this.$t("Active"),
					value: 1,
				},
				{
					text: this.$t("Passive"),
					value: 0,
				},
			],
			depotType_choices: [],
		};
	},
	watch: {
		companydata(val){
			console.log(val)
			return val
		},
		storehouseTypes(val) {
			return val;
		},
		isSidebarActiveStorehouse(val) {
			this.getStorehouseTypeList();
			if (this.ROLE == "Company") this.getCustomerinfoList();
			if (!this.isMobile()) this.$refs.scroll.$el.scrollTop = 0;
			if (!val) return;
			if (Object.entries(this.data).length === 0) {
				this.initValues();
				if (this.company) {
					this.customer = { value: this.company.value, name: this.company.name };
					this.getCustomerinfoListForCostumer();
				}
				this.$validator.reset();
			} else {
				this.customerinfo = {
					name: this.data.CompanyInfoName,
					value: this.data.CompanyInfoId,
				};
				const item = this.depotType_choices.find((item) => item.value == this.data.DepotType);

				const DepotTypename = item ? item.name : null;
				this.customer = { name: this.data.CompanyName, value: this.data.CompanyId };
				this.depotId = this.data.DepotId;
				this.depotType = { name: DepotTypename, value: this.data.DepotType };

				this.depotNo = this.data.DepotNo;
				this.country = this.data.Country;
				this.depotName = this.data.DepotName;
				this.groupCode = this.data.GroupCode;
				this.specCode1 = this.data.SpecCode1;
				this.specCode2 = this.data.SpecCode2;
				this.status = [
					{
						text: this.data.Status == 0 ? this.$t("Passive") : this.$t("Active"),
						value: this.data.Status,
					},
				];
				this.note = this.data.Note;
				this.cancelDate = this.data.CancelDate;
				this.description = this.data.Description;
				this.depotGroupId = this.data.DepotGroupId;
				this.remControl = this.data.RemControl;
				this.companyInfoId = this.data.CompanyInfoId;
				this.usingDropShiping =
					this.data.UsingDropShiping == null ? false : this.data.UsingDropShiping;
			}
			// Object.entries(this.data).length === 0 ? this.initValues() : { this.dataId, this.dataName, this.dataCategory, this.dataOrder_status, this.dataPrice } = JSON.parse(JSON.stringify(this.data))
		},
	},

	computed: {
		storehouseTypes: {
			get() {
				return this.$store.state.storehouse.StorehouseTypes;
			},
			set(val) {
				if (!val) {
				}
			},
		},
		companydata: {
			get() {
				return this.$store.state.customer.Customer;
			},
			set(val) {
				if (!val) {
				}
			},
		},
		isSidebarActiveLocal: {
			get() {
				return this.isSidebarActiveStorehouse;
			},
			set(val) {
				if (!val) {
					this.$emit("closeSidebar");
					// this.$validator.reset()
					// this.initValues()
				}
			},
		},
		isFormValid() {
			return !this.errors.any() && this.companyName && this.companyNo > 0;
		},
		scrollbarTag() {
			return this.$store.getters.scrollbarTag;
		},
	},
	methods: {
		getStorehouseTypeList() {
			this.storehouseTypesOption = [];
			this.depotType_choices = [];

			this.storehouseTypesOption = this.storehouseTypes;
			for (const [key, value] of Object.entries(this.storehouseTypesOption)) {
				this.depotType_choices.push({ value: key, name: this.$t(value) });
			}
		},
		getCustomerinfoListForCostumer() {
			const vs = this.$vs;
			this.$store
				.dispatch("customer/listCustomerInfoForCustomer", this.customer.value)
				.then((response) => {
					// let costumerList = JSON.parse(response.json);

					if (response.success == true) {
						this.customerinfo = "";
						this.customerinfo_choices = [];
						this.customerInfoList = this.$store.state.customer.CustomerInfoListForCustomer;

						this.customerInfoList.forEach((val, index) => {
							this.customerinfo_choices.push({
								value: val.CompanyInfoId,
								name: val.Name,
							});
						});
					} else console.log(response.statusText);
					/*	vs.notify({
						text: response.statusText,
						iconPack: "feather",
						icon: "icon-alert-circle",
						color: "danger",
						position: "top-center"
					});*/
				});
		},
		addInfoData(data) {
			this.infoData = { CompanyId: this.customer.value };
			this.addNewInfoDataSidebar = true;
		},
		closeInfoData() {
			this.addNewInfoDataSidebar = false;
		},
		addCustomerInfo() {
			this.getCustomerList(this.customer.value, "popup");
		},

		getCustomerList(id, popup) {
			const vs = this.$vs;
			this.customerListOption = [];
			this.customer_choices = [];

			this.customerListOption = this.companydata;
			this.customerListOption.forEach((val, index) => {
				this.customer_choices.push({ value: val.CompanyId, name: val.CompanyName });
			});

			if (id != "") {
				if (popup == "popup") {
					this.addInfoData();
				}
			}
		},

		parseDate(params) {
			return moment(String(params)).format("DD.MM.YYYY");
		},
		updateCustomer() {
			this.depotId = "";
			this.depotType = {
				text: this.$t("ProductEnter"),
				value: 1,
			};
			this.depotNo = "";
			this.country = "";
			this.depotName = "";
			this.groupCode = "";
			this.specCode1 = "";
			this.specCode2 = "";
			this.status = 0;
			this.note = "";
			this.cancelDate = "";
			this.description = "";
			this.depotGroupId = "";
			this.remControl = "";
			this.companyInfoId = "";
			this.customer = "";
			this.customerinfo = "";
			this.usingDropShiping = false;
		},
		initValues() {
			if (this.data.id) return;
			this.depotId = "";
			this.depotType = {
				text: this.$t("ProductEnter"),
				value: 1,
			};
			this.depotNo = "";
			this.country = "";
			this.depotName = "";
			this.groupCode = "";
			this.specCode1 = "";
			this.specCode2 = "";
			this.status = 0;
			this.note = "";
			this.cancelDate = "";
			this.description = "";
			this.depotGroupId = "";
			this.remControl = "";
			this.companyInfoId = "";
			this.customer = "";
			this.customerinfo = "";
			this.usingDropShiping = false;
		},
		getCustomerinfoList() {
			const vs = this.$vs;
			this.customerinfo = "";

			this.$store
				.dispatch("customer/listCustomerinfoForRole", this.customer.value)
				.then((response) => {
					// let costumerList = JSON.parse(response.json);

					if (response.success == true) {
						this.customerinfo_choices = [];
						this.customerInfoList = [];
						this.customerInfoList = this.$store.state.customer.CustomerInfoListForCustomer;
						this.customerInfoList.forEach((val, index) => {
							this.customerinfo_choices.push({
								value: val.CompanyInfoId,
								name: val.Name,
							});
						});
					} else console.log(response.statusText);
					/*	vs.notify({
						text: response.statusText,
						iconPack: "feather",
						icon: "icon-alert-circle",
						color: "danger",
						position: "top-center"
					});*/
				});
		},
		submitData() {
			var createdId = uuid.v4();
			var createdGroupId = uuid.v4();
			const vs = this.$vs;
			let myArray = [];
			const today = new Date();
			try {
				this.$validator.validateAll().then((result) => {
					if (result) {
						// if form have no errors

						let obj = {
							CompanyId: this.customer.value,

							CompanyName: this.customer.name,
							status: typeof this.status.value == "undefined" ? 1 : this.status.value,
							cancelDate: this.cancelDate == "" ? null : this.cancelDate,
							depotId: this.depotId != "" ? this.depotId : createdId,
							depotType: this.depotType.value, //?
							depotNo: this.depotNo,
							country: this.country,
							depotName: this.depotName,
							groupCode: this.groupCode,
							specCode1: this.specCode1,
							specCode2: this.specCode2,
							note: this.note,
							description: this.description,
							depotGroupId: this.depotGroupId != "" ? this.depotGroupId : createdGroupId,
							remControl: this.remControl,
							companyInfoId: this.customerinfo.value,
							CompanyInfoName: this.customerinfo.name,

							usingDropShiping: this.usingDropShiping == null ? false : this.usingDropShiping,
						};
						if (this.ROLE == "Company")
							obj = {
								CompanyInfoId: this.customerinfo.value,
								CompanyInfoName: this.customerinfo.name,
								status: typeof this.status.value == "undefined" ? 1 : this.status.value,
								cancelDate: this.cancelDate == "" ? null : this.cancelDate,
								depotId: this.depotId != "" ? this.depotId : createdId,
								depotType: this.depotType.value, //?
								depotNo: this.depotNo,
								country: this.country,
								depotName: this.depotName,
								groupCode: this.groupCode,
								specCode1: this.specCode1,
								specCode2: this.specCode2,
								note: this.note,
								description: this.description,
								depotGroupId:
									this.depotGroupId != "" ? this.depotGroupId : createdGroupId,
								remControl: this.remControl,
								companyInfoId: this.customerinfo.value,
								usingDropShiping: this.usingDropShiping == null ? false : this.usingDropShiping,
							};
						if (this.depotId != "") {
							let updateStorehouseMethod = "updateStorehouse"
							if (this.type == 'dropshipping')
								updateStorehouseMethod = "updateStorehouseDs"
							this.$store
								.dispatch("storehouse/"+updateStorehouseMethod, obj)
								.then((response) => {
									if (response.status == 200) {
										vs.notify({
											text: response.data.message,
											iconPack: "feather",
											icon: "icon-alert-circle",
											color: "success",
											position: "top-center",
										});
										this.$root.$emit("getStorehouseList");
										this.$emit("closeSidebar");
										this.initValues();
									} else {
										vs.notify({
											text: response.data.message.toString(),
											iconPack: "feather",
											icon: "icon-alert-circle",
											color: "danger",
											position: "top-center",
										});
									}
								})
								.catch((error) => {
									return new Promise((resolve, reject) => {
										resolve(false);
									});
								});
						} else {
							delete obj.id;
							obj.popularity = 0;
							let addStorehouseMethod = "addStorehouse"
							if (this.type == 'dropshipping')
								addStorehouseMethod = "addStorehouseDs"

							this.$store
								.dispatch("storehouse/" + addStorehouseMethod, obj)
								.then((response) => {
									if (response.status == 200) {
										vs.notify({
											text: response.data.message,
											iconPack: "feather",
											icon: "icon-alert-circle",
											color: "success",
											position: "top-center",
										});
										this.$root.$emit("getStorehouseList");
										this.initValues();
									} else {
										vs.notify({
											text: response.data.message.toString(),
											iconPack: "feather",
											icon: "icon-alert-circle",
											color: "danger",
											position: "top-center",
										});
									}
								})
								.catch((error) => {
									return new Promise((resolve, reject) => {
										resolve(false);
									});
								});
						}
					} else {
						vs.notify({
							text: this.$t("Validate"),
							iconPack: "feather",
							icon: "icon-alert-circle",
							color: "warning",
							position: "top-center",
						});
					}
				});
			} catch (error) {
				console.log(error);
			}
		},
		updateCurrImg(input) {
			const vs = this.$vs;
			if (input.target.files && input.target.files[0]) {
				const reader = new FileReader();

				if (input.target.files[0].size > 102400)
					vs.notify({
						text: this.$t("ImageSize"),
						iconPack: "feather",
						icon: "icon-alert-circle",
						color: "warning",
						position: "top-right",
					});
				else
					reader.onload = (e) => {
						this.companyLogo = e.target.result;
					};
				reader.readAsDataURL(input.target.files[0]);
			}
		},
	},
	created() {
		if (this.ROLE == "Owner" || this.ROLE == "Admin") this.getCustomerList();

		this.locale = this.$i18n.locale == "en" ? "en-US" : this.$i18n.locale;
		const dict = {
			custom: {
				depotNo: {
					required: this.$t("DepotNoRequired"),
					alpha: this.$t("DepotNoRequired"),
				},
				depotName: {
					required: this.$t("DepotNameRequired"),
					alpha: this.$t("DepotNameRequired"),
				},
				customer: {
					required: this.$t("CompanyNameRequired"),
					alpha: this.$t("CompanyNameRequired"),
				},
				customerinfo: {
					required: this.$t("customerinfoNameRequired"),
					alpha: this.$t("customerinfoNameRequired"),
				},
			},
		};
		Validator.localize("en", dict);
	},
};
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
	::v-deep .vs-sidebar--background {
		z-index: 52010;
	}

	::v-deep .vs-sidebar {
		z-index: 52010;
		width: 400px;
		max-width: 90vw;

		.img-upload {
			margin-top: 2rem;

			.con-img-upload {
				padding: 0;
			}

			.con-input-upload {
				width: 100%;
				margin: 0;
			}
		}
	}
}

.scroll-area--data-list-add-new {
	// height: calc(var(--vh, 1vh) * 100 - 4.3rem);
	height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 190px);

	&:not(.ps) {
		overflow-y: auto;
	}
}

.scroll-area--data-list-add-new-mobile2 {
	// height: calc(var(--vh, 1vh) * 100 - 4.3rem);
	height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 50px);

	&:not(.ps) {
		overflow-y: auto;
	}
}

.scroll-area--data-list-add-new-mobile {
	// height: calc(var(--vh, 1vh) * 100 - 4.3rem);
	height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 500px);

	&:not(.ps) {
		overflow-y: auto;
	}
}

.vs-input--label {
	color: black;
	font-size: small;
}
</style>
